export default function audioConfiguration() {

  return {
    restrict: 'E',
    templateUrl: 'assets/javascripts/xchelper/directives/audioConfiguration.html',
    controller: ($scope, mediaDevices, webRtcAudio, AudioDevicesMgrService, $rootScope, XucPhoneState, WebHIDHeadsetService, ExternalEvent) => {

      $scope.ringtoneDevices = [];
      $scope.audioDevices = [];
      $scope.microphoneDevices = [];
      $scope.headsetName = WebHIDHeadsetService.getCurrentDeviceName();

      $rootScope.$on(ExternalEvent.WEBHID_DEVICE_SELECTED, (_, device) => {
        console.debug(`Received ${device} in ContentSettingsController`);
        $scope.headsetName = device;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.AUDIO_DEVICE_PICKED_EVT, (_e, device) => {
        $scope.selectedAudioDevice = device.deviceId;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.MIC_DEVICE_PICKED_EVT, (_e, device) => {
        $scope.selectedMicrophoneDevice = device.deviceId;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.RINGING_DEVICE_PICKED_EVT, (_e, device) => {
        $scope.selectedRingingDevice = device.deviceId;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.AUDIO_DEVICE_UPDATE_EVT, (_e, devices) => {
        $scope.audioDevices = devices;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.MIC_DEVICE_UPDATE_EVT, (_e, devices) => {
        $scope.microphoneDevices = devices;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      $rootScope.$on(AudioDevicesMgrService.RINGING_DEVICE_UPDATE_EVT, (_e, devices) => {
        $scope.ringingDevices = devices;
        if (!$rootScope.$$phase) $scope.$apply();
      });

      AudioDevicesMgrService.initAudioDevices();

      $scope.changeAudioOutputDevice = (deviceId) => {
        AudioDevicesMgrService.changeAudioOutputDevice(deviceId);
      };

      $scope.changeAudioInputDevice = (deviceId) => {
        AudioDevicesMgrService.changeAudioInputDevice(deviceId);
      };

      $scope.changeRingingDevice = (deviceId) => {
        AudioDevicesMgrService.changeRingingDevice(deviceId);
      };

      $scope.getAudioInputStatus = () => {
        return XucPhoneState.getDeviceConference().calls.length > 0 ? 'disabled' : '';
      };
    }
  };
}
